import { useEffect } from 'react';
import { useCirculars } from '@/sections/circulars/useCirculars';
import { Hero } from '@/sections/home/Hero';
import { NoticesSection } from '@/sections/home/NoticesSection';
import { WhatIsITES } from '@/sections/home/WhatIsITES';
import { FactsBand } from '@/sections/home/FactsBand';
import { ContactStrip } from '@/sections/home/ContactStrip';

export function Home() {
  const { status, data, retry } = useCirculars();
  useEffect(() => {
    document.title = 'Indian Technical Education Society – Mumbai';
  }, []);

  return (
    <>
      <Hero />
      <NoticesSection status={status} items={data} retry={retry} />
      <WhatIsITES />
      <FactsBand />
      <ContactStrip />
    </>
  );
}
